// extracted by mini-css-extract-plugin
export default {"msgM":"eaba0685d1"};